/* eslint-disable @typescript-eslint/no-explicit-any */

export default function LoadingButton(): any {
  return {
    MuiLoadingButton: {
      styleOverrides: {
        root: {
          "&.MuiButton-text": {
            "& .MuiLoadingButton-startIconPendingStart": { marginLeft: 0 },
            "& .MuiLoadingButton-endIconPendingEnd": { marginRight: 0 },
          },
        },
      },
    },
  };
}
